import { PublicAmendmentSearchProvider } from './context/public-amendment-search-context';
import { PublicAmendmentSearchComponent } from './public-amendment-search-component';

export function PublicAmendmentSearchFactory() {
    return (
        <PublicAmendmentSearchProvider>
            <PublicAmendmentSearchComponent />
        </PublicAmendmentSearchProvider>
    );
}
